{
  "greeting": {
    "salam": "আসসালামু আলাইকুম",
    "salamWithName": "আসসালামু আলাইকুম, {{name}}"
  },
  "dock": {
    "saved": "সংরক্ষিত",
    "savedVerses": "সংরক্ষিত আয়াত",
    "tasks": "কাজ",
    "notes": "নোট"
  },
  "actions": {
    "save": "সংরক্ষণ",
    "cancel": "বাতিল",
    "close": "বন্ধ",
    "delete": "মুছুন",
    "rename": "নাম পরিবর্তন",
    "dismiss": "খারিজ",
    "loading": "লোড হচ্ছে…",
    "reload": "পুনরায় লোড",
    "retry": "আবার চেষ্টা করুন",
    "expand": "প্রসারিত করুন",
    "collapse": "সংকুচিত করুন"
  },
  "nav": {
    "appNavigation_aria": "অ্যাপ নেভিগেশন"
  },
  "tabs": {
    "home": "হোম",
    "tasks": "কাজ",
    "notes": "নোট",
    "more": "আরও"
  },
  "more": {
    "daily": "দৈনিক",
    "account": "অ্যাকাউন্ট",
    "savedVerses": "সংরক্ষিত আয়াত",
    "qibla": "কিবলা",
    "prayerTimes": "নামাজের সময় ও অনুস্মারক",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "আপনার Rhemn অ্যাকাউন্টের মাধ্যমে পরিচালিত",
    "upgrade": "আপগ্রেড",
    "privacyPolicy": "গোপনীয়তা নীতি",
    "version": "Rhemn · v{{version}}",
    "back_aria": "পেছনে",
    "deleteAccount": "অ্যাকাউন্ট মুছুন"
  },
  "reflection": {
    "dismiss_aria": "ভাবনা খারিজ করুন"
  },
  "app": {
    "loading_aria": "Rhemn লোড হচ্ছে",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "ওয়েবে আপনার Rhemn Pro সাবস্ক্রিপশন পরিচালনা করুন। আপনি যখন আপনার সাবস্ক্রাইব করা অ্যাকাউন্ট দিয়ে সাইন ইন করবেন, Pro এখানে স্বয়ংক্রিয়ভাবে চালু হবে।"
  },
  "header": {
    "qiblaDirection_aria": "কিবলার দিক",
    "prayerTimes_aria": "নামাজের সময়",
    "prayerTimesTitle": "নামাজের সময়",
    "method": "পদ্ধতি",
    "methodHelp": "পদ্ধতি গণনাকৃত সময়কে প্রভাবিত করে"
  },
  "search": {
    "search_aria": "অনুসন্ধান",
    "searchLabel": "অনুসন্ধান",
    "searchWeb_placeholder": "ওয়েবে অনুসন্ধান করুন"
  },
  "focus": {
    "input_placeholder": "আজ সবচেয়ে গুরুত্বপূর্ণ কী?",
    "example_worship": "তাড়াহুড়ো নয়, মনোযোগ দিয়ে নামাজ পড়া",
    "example_kindness": "শুধু মায়ের কথা শুনতে তাঁকে ফোন করা",
    "example_reflect": "আজকের আয়াতের সাথে আপনার নিয়ত নিয়ে ভাবুন",
    "saveIntention_aria": "নিয়ত সংরক্ষণ করুন",
    "celebration": "🤲 মাশাআল্লাহ"
  },
  "profile": {
    "profileFallback": "প্রোফাইল",
    "profileAndAccount_aria": "প্রোফাইল ও অ্যাকাউন্ট",
    "profileDialog_aria": "প্রোফাইল",
    "editName_aria": "আপনার নাম সম্পাদনা করুন",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "সাবস্ক্রিপশন পরিচালনা করুন",
    "manageSubscription_aria": "আপনার Rehmn Pro সাবস্ক্রিপশন পরিচালনা করুন",
    "anonymousAnalytics": "বেনামী বিশ্লেষণ",
    "anonymousAnalyticsNote": "শুধুমাত্র সমষ্টিগত — কখনও আপনার সাথে সংযুক্ত নয়",
    "shareAnalytics_aria": "বেনামী ব্যবহারের বিশ্লেষণ শেয়ার করুন",
    "signOut": "সাইন আউট",
    "signingOut": "সাইন আউট হচ্ছে…",
    "signOut_aria": "Rehmn থেকে সাইন আউট করুন",
    "restorePurchases": "Restore purchases",
    "restorePurchases_aria": "Restore previous purchases"
  },
  "background": {
    "loading": "ব্যাকগ্রাউন্ড লোড হচ্ছে...",
    "fallbackNotice": "বিকল্প ছবি ব্যবহার করা হচ্ছে (Unsplash API অনুপলব্ধ)",
    "noImage": "কোনো ব্যাকগ্রাউন্ড ছবি উপলব্ধ নেই",
    "error": "ত্রুটি: {{message}}",
    "photoByOnUnsplash": "ছবি তুলেছেন <photographer>{{name}}</photographer> · <unsplash>Unsplash</unsplash>-এ"
  },
  "error": {
    "title": "কিছু একটা ভুল হয়েছে",
    "fallbackMessage": "একটি অপ্রত্যাশিত ত্রুটি ঘটেছে।"
  },
  "theme": {
    "switchToLight_title": "লাইট মোডে যান",
    "switchToDark_title": "ডার্ক মোডে যান"
  },
  "upgradeCta": {
    "upgradeToPro": "Pro-তে আপগ্রেড করুন",
    "restorePurchases": "Restore purchases",
    "restoring": "Restoring…",
    "restoreEmpty": "No purchases found.",
    "pricePerMonth": "{{price}} / মাস",
    "pricePerYear": "{{price}} / বছর",
    "purchasePending": "অনুমোদনের অপেক্ষায়। কেনাকাটা অনুমোদিত হলে Pro স্বয়ংক্রিয়ভাবে চালু হয়ে যাবে।",
    "storeUnavailable": "এই মুহূর্তে App Store-এ পৌঁছানো যাচ্ছে না। একটু পরে আবার চেষ্টা করুন।",
    "purchaseFailed": "কেনাকাটা সম্পন্ন করা যায়নি। একটু পরে আবার চেষ্টা করুন।"
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · প্রথম বছরে ২৫% ছাড়",
    "title": "আপনার নামাজের মাঝের সময়গুলোর জন্য।",
    "body": "ভয়েস নোট যা লিখিত রূপ নেয়, সারসংক্ষেপ হয় এবং কাজে পরিণত হয়। আপনার নামাজের সময় ঘিরে সাজানো দিনের পরিকল্পনা। AI সহ নোট।",
    "price": "$29.99",
    "period": "আপনার প্রথম বছরের জন্য",
    "priceIos": "প্রথম বছরে ২৫% ছাড়",
    "terms": "এরপর বছরে $39.99। কোড {{code}} আপনার জন্য প্রয়োগ করা হয়েছে।",
    "termsIos": "নিয়মিত বার্ষিক মূল্যে নবায়ন হয়। App Store-এ কোড {{code}} ব্যবহার করুন।",
    "free": "নামাজের সময়, কিবলা, দৈনিক আয়াত এবং কাজগুলো বিনামূল্যেই থাকবে।",
    "cta": "Pro-তে আপগ্রেড করুন",
    "dismiss": "এখন নয়"
  },
  "planChooser": {
    "monthly": "মাসিক",
    "yearly": "বার্ষিক",
    "yearlyValue": "চার মাস আমাদের পক্ষ থেকে।",
    "freeNote": "নামাজের সময়, কিবলা, দিনের আয়াত ও কাজ ফ্রি। Rhemn Pro যোগ করে:",
    "includes_planner": "পাঁচ ওয়াক্ত নামাজকে ঘিরে সাজানো দিনের পরিকল্পনা, আর “আমার দিন সাজান”",
    "includes_insights": "কুরআন ইনসাইটস — যেকোনো আয়াত নিয়ে প্রশ্ন করুন, প্রেক্ষাপট পড়ুন",
    "includes_reflections": "আপনার নিয়ত অনুযায়ী লেখা দিনের আয়াতের প্রতিফলন",
    "includes_notes": "নোট ও ভয়েস নোট, AI সারসংক্ষেপ ও পরিচ্ছন্নতাসহ",
    "includes_extras": "সংরক্ষিত আয়াত, আয়াত কার্ড, স্ট্রিক ও ৫ দিনের পূর্বাভাস",
    "renewsMonthly": "বাতিল না করা পর্যন্ত প্রতি মাসে নবায়ন হয়",
    "renewsYearly": "বাতিল না করা পর্যন্ত প্রতি ১২ মাসে নবায়ন হয়",
    "continue": "চালিয়ে যান",
    "renewalTerms": "নিশ্চিত করার সময় আপনার Apple ID থেকে অর্থ কাটা হবে। মেয়াদ শেষ হওয়ার অন্তত ২৪ ঘণ্টা আগে স্বয়ংক্রিয় নবায়ন বন্ধ না করলে সাবস্ক্রিপশন স্বয়ংক্রিয়ভাবে নবায়ন হবে। Apple ID সেটিংস থেকে যেকোনো সময় পরিচালনা বা বাতিল করুন।",
    "retry": "আবার চেষ্টা করুন"
  },
  "streak": {
    "badge_aria": "দৈনিক ধারাবাহিকতা — {{count}} দিন",
    "title": "দৈনিক ধারাবাহিকতা",
    "daysWithCount": "{{count}} দিনের ধারাবাহিকতা",
    "start": "আজই শুরু করুন — আয়াতের সাথে একটু সময় কাটান বা একটি নামাজ চিহ্নিত করুন।",
    "prayedToday": "আজ নামাজ পড়েছি",
    "readVerse": "আজকের আয়াত পড়েছি",
    "autoHint": "আয়াতের সাথে একটু সময় কাটালে তা নিজে থেকেই চিহ্নিত হয়ে যায়।",
    "milestoneTitle": "{{count}} দিনের নিয়ত",
    "milestoneBody": "আলহামদুলিল্লাহ। এই মাইলফলকটি শেয়ার করুন — আপনার প্রিয় কেউও হয়তো শুরু করবেন।",
    "share": "শেয়ার করুন",
    "dismiss": "এখন নয়",
    "cardLabel": "দিনের নিয়ত",
    "shareCaption": "নিয়তের সাথে শুরু করার {{count}} দিন — rhemn.com",
    "imageSaved": "ছবি সংরক্ষিত হয়েছে।",
    "couldNotCreateImage": "ছবি তৈরি করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।"
  },
  "qibla": {
    "compassIcon_aria": "কম্পাস আইকন",
    "title": "কিবলার দিক",
    "locationUnavailable": "অবস্থান অনুপলব্ধ",
    "locating": "অবস্থান নির্ণয় হচ্ছে…",
    "compass_aria": "কিবলা কম্পাস",
    "directionN": "উ",
    "directionE": "পূ",
    "directionS": "দ",
    "directionW": "প",
    "facingQibla": "কিবলার দিকে মুখ করা",
    "enableLiveCompass": "লাইভ কম্পাস চালু করুন",
    "enableLiveCompassNote": "মোশন সেন্সর ব্যবহার করে যাতে আপনি ঘুরলে তীরটি অনুসরণ করে — অবস্থান নয়",
    "directionToMecca": "মক্কার দিক",
    "enableLocation": "দিক গণনা করতে অবস্থান অ্যাক্সেস চালু করুন",
    "hintLive": "তীরটি প্রকৃত সময়ে আপনার ডিভাইসের অভিমুখ অনুসরণ করে",
    "hintStatic": "উত্তর থেকে দিকনির্দেশ — সঠিক দিকের জন্য একটি কম্পাসের সাথে ব্যবহার করুন",
    "live": "লাইভ",
    "footerVerse": "\"সুতরাং তুমি মসজিদুল হারামের দিকে মুখ ফিরাও\" – কুরআন ২:১৪৪"
  },
  "legal": {
    "links_aria": "আইনি",
    "termsOfUse": "ব্যবহারের শর্তাবলী",
    "privacyPolicy": "গোপনীয়তা নীতি"
  },
  "auth": {
    "signInForPro": "আগে সাইন ইন করুন — আপনার Pro সর্বত্র আপনার সাথে যায়।"
  },
  "integrations": {
    "row": {
      "label": "ক্যালেন্ডার ও কাজ",
      "caption": "সংযুক্ত",
      "subNone": "সংযুক্ত নয়",
      "subFree": "Google Calendar, Google Tasks এবং আরও",
      "subAttention": "{{provider}}-এ মনোযোগ প্রয়োজন",
      "subPaused": "সিঙ্ক স্থগিত"
    },
    "list": {
      "title": "ক্যালেন্ডার ও কাজ",
      "subtitle": "আপনার মিটিং ও করণীয় কাজ আপনার দিনে নিয়ে আসুন।",
      "footnote": "Rhemn শুধু যা প্রয়োজন তাই পড়ে, এবং আপনার ইভেন্ট কখনও সংরক্ষণ করে না।",
      "privacy": "গোপনীয়তা নীতি",
      "connect": "সংযুক্ত করুন",
      "connect_aria": "{{what}} সংযুক্ত করুন",
      "checking": "যাচাই করা হচ্ছে…",
      "loadError": "আপনার সংযোগ লোড করা যায়নি।",
      "tryAgain": "আবার চেষ্টা করুন",
      "offline": "আপনি অফলাইনে আছেন। আবার অনলাইনে এলে সংযুক্ত করুন।",
      "unavailable": "ক্যালেন্ডার ও কাজ এখন অনুপলব্ধ।",
      "disconnected": "{{provider}} সংযোগ বিচ্ছিন্ন হয়েছে।",
      "google": {
        "name": "Google",
        "sub": "ক্যালেন্ডার ও কাজ",
        "what": "Google Calendar এবং Google Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "কাজ ও প্রকল্প",
        "what": "Todoist"
      },
      "apple": {
        "name": "ক্যালেন্ডার ও রিমাইন্ডার",
        "subNative": "এই {{device}}-এ",
        "subSafari": "iPhone ও Mac-এর জন্য Rhemn অ্যাপে"
      },
      "synced": "{{when}} সিঙ্ক হয়েছে",
      "connectedSub": "সংযুক্ত",
      "syncing": "সিঙ্ক হচ্ছে…",
      "reconnectSub": "সিঙ্ক চালু রাখতে পুনরায় সংযুক্ত করুন",
      "errorSub": "শেষ সিঙ্ক সম্পূর্ণ হয়নি",
      "pausedSub": "স্থগিত · Rhemn Pro শেষ হয়েছে"
    },
    "explainer": {
      "google": {
        "title": "Google Calendar ও Google Tasks সংযুক্ত করুন",
        "p1Lead": "আপনার ক্যালেন্ডার, শুধু পড়ার জন্য",
        "p1Body": "Rhemn আপনার দিনে আপনার ইভেন্ট দেখায় এবং জানে কখন আপনি ব্যস্ত। এটি সেগুলো সংরক্ষণ করে না।",
        "p2Lead": "Google Tasks, উভয় দিকে",
        "p2Body": "আপনার বেছে নেওয়া তালিকাগুলো সিঙ্ক থাকে, তাই আপনি যেকোনো জায়গা থেকে টিক দিতে পারেন।",
        "p3Lead": "চাইলেই বাতিল করা যায়",
        "p3Body": "যেকোনো সময় সংযোগ বিচ্ছিন্ন করুন, এখানে বা আপনার Google অ্যাকাউন্টে।",
        "footnote": "Rhemn ঠিক কী চাইছে তা Google দেখাবে।"
      },
      "todoist": {
        "title": "Todoist সংযুক্ত করুন",
        "p1Lead": "আপনার প্রকল্প, উভয় দিকে",
        "p1Body": "আপনার বেছে নেওয়া প্রকল্পগুলো সিঙ্ক থাকে, তাই আপনি যেকোনো জায়গা থেকে টিক দিতে পারেন।",
        "p2Lead": "যেভাবে এটি মেলে",
        "p2Body": "Todoist-এর অগ্রাধিকার হয়ে যায় জরুরি, উচ্চ, মাঝারি ও নিম্ন। এক স্তরের বেশি গভীর উপ-কাজগুলো তাদের প্রধান কাজের নিচে ধাপ হিসেবে দেখা যায়।",
        "p3Lead": "চাইলেই বাতিল করা যায়",
        "p3Body": "যেকোনো সময় সংযোগ বিচ্ছিন্ন করুন, এখানে বা Todoist-এর সেটিংসে।",
        "cta": "Todoist-এ এগিয়ে যান",
        "footnote": "Todoist আপনাকে নিশ্চিত করতে বলবে।"
      },
      "skip": "এখন নয়",
      "cancel": "বাতিল",
      "waiting": "{{provider}}-এর জন্য অপেক্ষা করা হচ্ছে…",
      "safariWaiting": "নতুন ট্যাবে শেষ করুন, তারপর এখানে ফিরে আসুন।",
      "safariReopen": "ট্যাবটি আবার খুলুন",
      "denied": "{{provider}} অ্যাক্সেস দেয়নি, তাই কিছু সংযুক্ত হয়নি।",
      "error": "{{provider}}-এ সংযুক্ত করা যায়নি। একটু পরে আবার চেষ্টা করুন।"
    },
    "detail": {
      "back_aria": "ক্যালেন্ডার ও কাজ-এ ফিরে যান",
      "syncNow": "এখনই সিঙ্ক করুন",
      "intro": "Rhemn কী সিঙ্ক করবে তা বেছে নিন। যেকোনো সময় এটি পরিবর্তন করতে পারেন।",
      "taskLists": "কাজের তালিকা",
      "projects": "প্রকল্প",
      "reminders": "রিমাইন্ডার",
      "calendars": "ক্যালেন্ডার",
      "rhemnCalendarSub": "আপনার নামাজের সময়, ব্যস্ত হিসেবে গণনা করা হয় না",
      "loading": "লোড হচ্ছে…",
      "loadError": "আপনার তালিকা লোড করা যায়নি।",
      "emptyGoogle": "Google Tasks-এ কোনো কাজের তালিকা নেই।",
      "emptyTodoist": "Todoist-এ কোনো প্রকল্প নেই।",
      "addError": "{{name}} যোগ করা যায়নি। আবার চেষ্টা করুন।",
      "removed": "Rhemn থেকে সরানো হয়েছে। এটি এখনও {{provider}}-এ আছে।",
      "undo": "পূর্বাবস্থায় ফেরান",
      "prayerTimes": "আপনার ক্যালেন্ডারে নামাজের সময় যোগ করুন",
      "prayerTimesSub": "পরবর্তী ৭ দিনের জন্য Rhemn নামের একটি ক্যালেন্ডারে পাঁচ ওয়াক্ত নামাজ যোগ করে, যাতে কেউ সেই সময়ে বুক না করে।",
      "prayerTimesOn": "চালু। {{date}} পর্যন্ত যোগ করা হয়েছে।",
      "prayerTimesWaiting": "Google-এর জন্য অপেক্ষা করা হচ্ছে…",
      "prayerTimesDenied": "Google এটি অনুমতি দেয়নি। কিছু যোগ করা হয়নি।",
      "prayerTimesRemoveAsk": "আপনার ক্যালেন্ডার থেকে Rhemn-এর নামাজের সময় সরাতে চান?",
      "prayerTimesKeep": "রেখে দিন",
      "prayerTimesRemove": "সরান",
      "meetingPrompts": "মিটিং অনুস্মারক",
      "meetingPromptsSub": "লিংকসহ একটি মিটিং শুরু হওয়ার আগে, নোট নেওয়ার প্রস্তাব দেয়।",
      "busyFootnote": "\"আমার দিন পরিকল্পনা করুন\" শুধু দেখে আপনি কখন ব্যস্ত, কখনও আপনার মিটিং কী তা নয়।",
      "todoistFootnote": "Todoist-এর অগ্রাধিকার হয়ে যায় জরুরি, উচ্চ, মাঝারি ও নিম্ন। এক স্তরের বেশি গভীর উপ-কাজগুলো তাদের প্রধান কাজের নিচে ধাপ হিসেবে দেখা যায়।",
      "reauth": "{{provider}} আর Rhemn-কে সিঙ্ক করতে দিচ্ছে না। অ্যাক্সেস সরানো হলে বা পাসওয়ার্ড বদলালে এমন হয়।",
      "reconnect": "পুনরায় সংযুক্ত করুন",
      "paused": "Rhemn Pro শেষ হয়ে যাওয়ায় সিঙ্ক স্থগিত আছে। আপনার তালিকা যেমন ছিল তেমনই থাকবে।",
      "calendarDenied": "ক্যালেন্ডার অ্যাক্সেস বন্ধ আছে।",
      "remindersDenied": "রিমাইন্ডার অ্যাক্সেস বন্ধ আছে।",
      "disconnect": "{{provider}} সংযোগ বিচ্ছিন্ন করুন",
      "disconnectTitle": "{{provider}} সংযোগ বিচ্ছিন্ন করবেন?",
      "disconnectBody": "{{provider}}-এ কিছু মুছে ফেলা হয় না।",
      "disconnectRhemnCal": "আপনার Rhemn নামাজের সময়ের ক্যালেন্ডারটি Google Calendar থেকে সরানো হবে।",
      "disconnectError": "{{provider}} সংযোগ বিচ্ছিন্ন করা যায়নি। একটু পরে আবার চেষ্টা করুন।",
      "keepLists": "আমার তালিকা Rhemn-এ রাখুন",
      "keepListsSub": "সেগুলো সিঙ্ক হওয়া বন্ধ করে সাধারণ Rhemn তালিকা হয়ে যাবে।",
      "removeLists": "সেগুলো Rhemn থেকে সরান",
      "removeListsSub": "শুধু Rhemn-এর কপিগুলো সরানো হবে।",
      "disconnecting": "সংযোগ বিচ্ছিন্ন হচ্ছে…",
      "appleStop": "ক্যালেন্ডার ও রিমাইন্ডার ব্যবহার বন্ধ করুন",
      "appleStopTitle": "ক্যালেন্ডার ও রিমাইন্ডার ব্যবহার বন্ধ করবেন?",
      "appleStopBody": "Rhemn আপনার ইভেন্ট ও রিমাইন্ডার দেখানো বন্ধ করবে। এর অ্যাক্সেস সম্পূর্ণভাবে সরাতে, সেটিংসে গিয়ে এটি বন্ধ করুন।",
      "justNow": "এইমাত্র",
      "tasksScope": "আপনার Google Tasks দেখতে Rhemn-এর অনুমতি প্রয়োজন। পুনরায় সংযুক্ত করুন এবং অনুমতি দিতে Tasks চিহ্নিত করুন।",
      "calendarsLoadError": "আপনার ক্যালেন্ডার লোড করা যায়নি।",
      "calendarsEmpty": "এই অ্যাকাউন্টে কোনো ক্যালেন্ডার নেই।",
      "calendarsScope": "আপনার Google Calendar দেখতে Rhemn-এর অনুমতি প্রয়োজন। অনুমতি দিতে পুনরায় সংযুক্ত করে Calendar-এ টিক দিন।",
      "prayerTimesError": "আপনার নামাজের সময় যোগ করা যায়নি। একটু পরে আবার চেষ্টা করুন।",
      "remindersEmpty": "রিমাইন্ডারে কোনো তালিকা নেই।",
      "openSettings": "সেটিংস খুলুন",
      "appleStopCta": "ব্যবহার বন্ধ করুন"
    },
    "locked": {
      "body": "আপনার নামাজের সময়ের মধ্যেই আপনার মিটিং দেখুন, এবং Google Tasks Rhemn-এর সাথে সিঙ্ক রাখুন।",
      "googleName": "Google Calendar ও Google Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "ডিভাইস"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, {{provider}}-এর সাথে সিঙ্ক হয়েছে",
      "unlinkConfirm": "“{{name}}” Rhemn থেকে সরাবেন? এটি {{provider}}-এ থেকে যাবে।",
      "remove": "সরান",
      "offline": "অফলাইন · আপনি আবার অনলাইনে এলে পরিবর্তনগুলো {{provider}}-এর সাথে সিঙ্ক হবে।",
      "stillSyncing": "{{provider}}-এর সাথে সিঙ্ক এখনও চলছে…",
      "failed_one": "{{count}}টি পরিবর্তন {{provider}}-এ পৌঁছায়নি।",
      "failed_other": "{{count}}টি পরিবর্তন {{provider}}-এ পৌঁছায়নি।",
      "retry": "আবার চেষ্টা করুন",
      "needsReconnect": "{{provider}} আপনাকে পুনরায় সংযুক্ত হতে বলছে।",
      "paused": "সিঙ্ক স্থগিত · Rhemn Pro শেষ হয়েছে।",
      "upgrade": "আপগ্রেড",
      "notSynced": "সিঙ্ক হয়নি",
      "notSynced_aria": "{{provider}}-এর সাথে সিঙ্ক হয়নি। আবার চেষ্টা করুন।",
      "remindersOff": "Rhemn রিমাইন্ডারে পৌঁছাতে পারছে না। সেটিংসে গিয়ে আবার চালু করুন।",
      "dueToday": "আজ",
      "dueTomorrow": "আগামীকাল",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "সারাদিন",
      "more": "+{{count}}",
      "more_aria": "সারাদিনের আরও {{count}}টি ইভেন্ট দেখান",
      "less_aria": "সারাদিনের কম ইভেন্ট দেখান",
      "events_aria": "ইভেন্ট",
      "event_aria": "{{start}} থেকে {{end}}, {{title}}",
      "allDayEvent_aria": "সারাদিন, {{title}}",
      "untitled": "ব্যস্ত",
      "now": "এখন · {{end}} পর্যন্ত",
      "until": "{{end}} পর্যন্ত",
      "into": "· {{prayer}} পর্যন্ত",
      "loadError": "আপনার ক্যালেন্ডার লোড করা যায়নি।",
      "needsReconnect": "Google Calendar আপনাকে পুনরায় সংযুক্ত হতে বলছে।",
      "scope": "Rhemn আপনার Google Calendar দেখতে পারছে না। অনুমতি দিতে পুনরায় সংযুক্ত করে Calendar-এ টিক দিন।",
      "appleOff": "Rhemn আপনার ক্যালেন্ডার দেখতে পারছে না। সেটিংসে এটি আবার চালু করুন।"
    },
    "plan": {
      "mostlyMeetings": "বেশিরভাগই মিটিং · {{duration}} ফাঁকা",
      "noFreeTime": "কোনো ফাঁকা সময় নেই",
      "aroundMeetings_one": "{{count}}টি মিটিং ঘিরে সাজানো হয়েছে।",
      "aroundMeetings_other": "{{count}}টি মিটিং ঘিরে সাজানো হয়েছে।",
      "settledBusy": "সবকিছু ইতিমধ্যে আপনার মিটিংয়ের ফাঁকে মিলে গেছে।"
    },
    "meeting": {
      "group_aria": "মিটিং শুরু হচ্ছে",
      "now": "এখন",
      "takeNotes": "নোট নিন",
      "takeNotes_aria": "{{title}}-এর নোট নিন",
      "dismiss_aria": "বাতিল",
      "announce": "{{title}} {{when}} শুরু হবে।",
      "announceNow": "{{title}} এখন শুরু হচ্ছে।",
      "yourMeeting": "আপনার মিটিং"
    },
    "apple": {
      "primer": {
        "title": "নামাজের পাশে আপনার ক্যালেন্ডার দেখুন",
        "body": "আপনার দিনে সাজাতে Rhemn এই {{device}}-এর ইভেন্ট ও রিমাইন্ডার পড়ে। এগুলো আপনার ডিভাইসেই থাকে। আমার দিন সাজান শুধু আপনার ব্যস্ত সময়গুলো ব্যবহার করে।",
        "cta": "চালিয়ে যান",
        "skip": "এখন নয়",
        "footnote": "{{device}} দুবার জিজ্ঞেস করবে, একবার ক্যালেন্ডারের জন্য আর একবার রিমাইন্ডারের জন্য। সেটিংসে যেকোনোটি বদলাতে পারবেন।"
      }
    }
  }
}
